import { Outlet } from 'react-router-dom';
import type { Reservation } from '@repo/domain';
import { useReservationsLive } from '@repo/domain-service';

export interface ReservationsOutletContext {
  pendingReservation: Reservation | undefined;
  ongoingReservations: Reservation[];
  loadingReservations: boolean;
}

const isPending = (reservation: Reservation): boolean => reservation.status === 'pending';
const isOngoing = (reservation: Reservation): boolean =>
  reservation.status === 'confirmed' || reservation.status === 'active';

export default function ReservationsProvider() {
  const { reservations, loadingReservations } = useReservationsLive(
    { only: 'current' },
    { withSpot: true, sortBy: 'startAtAsc' }
  );

  const context: ReservationsOutletContext = {
    pendingReservation: reservations.find(isPending),
    ongoingReservations: reservations.filter(isOngoing),
    loadingReservations,
  };

  return <Outlet context={context} />;
}
